var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24-not_active"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 12,
    cy: 12,
    r: 8,
    transform: "rotate(-180 12 12)",
    fill: "#19252E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1768 14.1161L13.0607 12L15.1768 9.88389C15.3721 9.68863 15.3721 9.37204 15.1768 9.17678L14.8232 8.82323C14.628 8.62796 14.3114 8.62796 14.1161 8.82323L12 10.9393L9.8839 8.82323C9.68864 8.62796 9.37206 8.62796 9.1768 8.82323L8.82324 9.17678C8.62798 9.37204 8.62798 9.68862 8.82324 9.88389L10.9394 12L8.82324 14.1161C8.62798 14.3114 8.62798 14.628 8.82324 14.8232L9.1768 15.1768C9.37206 15.372 9.68864 15.372 9.8839 15.1768L12 13.0607L14.1161 15.1768C14.3114 15.372 14.628 15.372 14.8232 15.1768L15.1768 14.8232C15.3721 14.628 15.3721 14.3114 15.1768 14.1161Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not_active.7e5b1d45f9ed1580a1089bf86cf2bd12.svg";